/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListadoFarmacoPacienteDto } from '../../models/listado-farmaco-paciente-dto';

export interface FarmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria$Params {
}

export function farmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria(http: HttpClient, rootUrl: string, params?: FarmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ListadoFarmacoPacienteDto>>> {
  const rb = new RequestBuilder(rootUrl, farmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ListadoFarmacoPacienteDto>>;
    })
  );
}

farmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria.PATH = '/api/farmacos/farmacos-paciente-farmacia-hospitalaria';
